import React from "react";

export const TermsText = (props) => {
  return (
    <div id="terms" className="text-center">
      <div className="containerInfo">
        <div className="section-title">
          <article className="arti">
            <h1 className="headerInfo">ColorYou Terms of Service</h1>
            <p>
              By downloading or using the app, you agree to these Terms. Please
              read them carefully before using the app. On iOS, use is also
              governed by the Apple Standard EULA available at{" "}
              <a
                href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.apple.com/legal/internet-services/itunes/dev/stdeula/
              </a>
              . On Android, use is governed by the{" "}
              <a
                href="https://play.google.com/intl/en/about/play-terms/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Play Terms of Service
              </a>
              , including applicable purchase and refund policies{" "}
              <a
                href="https://support.google.com/googleplay/answer/2479637?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                (refund policy)
              </a>
              . These Terms complement those agreements.
            </p>

            <span className="sep"></span>
            <br />

            <h1 className="headerInfo2">
              1. License and intellectual property
            </h1>
            <p>
              We grant you a personal, non-exclusive, non-transferable, and
              revocable license to use the app in accordance with these Terms
              and applicable law. You may not copy or modify the app or any part
              of it, remove or alter trademarks, attempt to extract source code,
              decompile, reverse engineer, translate, or create derivative
              works. The app and all associated intellectual property rights are
              owned by ColorYou or its licensors.
            </p>

            <h1 className="headerInfo2">
              2. Changes to the app and possible charges
            </h1>
            <p>
              We work to keep the app useful and efficient. We may make changes
              to the app or charge for certain services at any time. We will
              never charge you without clearly indicating the purpose and price
              on the store purchase sheet.
            </p>

            <h1 className="headerInfo2">3. In-app purchases</h1>
            <p>The app offers two paid access options:</p>
            <ul>
              <li>
                a) <strong>One-Week Premium Access</strong>, a non-renewing
                7-day access that unlocks all premium features.
              </li>
              <li>
                b) <strong>Lifetime Access (one-time purchase)</strong>, a
                one-time purchase that unlocks all premium features without
                recurring fees.
              </li>
            </ul>
            <p>
              Pricing is shown on the purchase sheet and may vary by country.
              Purchases are processed by Apple or Google. ColorYou does not
              access your payment data. Refunds are handled according to Apple’s
              or Google’s policies. Purchases are linked to your Apple ID or
              Google Play account and can be restored with the same account via
              the “Restore Purchases” option. We do not offer auto-renewable
              subscriptions. Access to paid content is subject to the
              availability of the app and the service. Taxes and billing are
              determined by Apple or Google based on your country of residence.
              Any billing issues must be handled with the respective store.
            </p>

            <h1 className="headerInfo2">4. Privacy and data</h1>
            <p>
              The app may store on your device (only on your device) personal
              data you provide to deliver the service. See our Privacy Policy
              for what data we process, for what purposes, and your rights:{" "}
              <a
                href="https://coloryou.app/#/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://coloryou.app/#/privacy
              </a>
              .
            </p>

            <h1 className="headerInfo2">5. Device permissions</h1>
            <p>
              The app requests access to protected resources such as the camera
              and photo library for features described in the app, for example
              taking a selfie for color analysis or photographing fabrics or
              patterns you want to try. If you do not grant permissions, some
              features may be unavailable.
            </p>

            <h1 className="headerInfo2">6. Device security</h1>
            <p>
              You are responsible for keeping your phone and access to the app
              secure. We do not recommend jailbreaking or rooting your device,
              as it may expose it to malware, compromise security, and affect
              the app’s proper operation.
            </p>

            <h1 className="headerInfo2">7. Connectivity and carrier charges</h1>
            <p>
              Some features require an Internet connection. ColorYou is not
              responsible if the app does not function fully due to lack of
              connectivity or data limits. If you use the app without Wi-Fi,
              your carrier may apply data or roaming charges. By using the app,
              you accept responsibility for such charges.
            </p>

            <h1 className="headerInfo2">
              8. Availability, updates, and compatibility
            </h1>
            <p>
              The app is available for iOS and Android. Requirements may change,
              and you may need to install updates to continue using the app. We
              do not guarantee the app will always remain updated or compatible
              with all OS versions. We may discontinue the app or terminate its
              use at any time. Upon termination, the rights granted to you will
              cease and you must stop using the app and, if applicable,
              uninstall it.
            </p>

            <h1 className="headerInfo2">9. Limitation of liability</h1>
            <p>
              Although we strive to keep the app up to date and accurate, we
              rely on third-party information. To the extent permitted by law,
              ColorYou is not liable for direct or indirect losses arising from
              use of the app, service interruptions, changes in availability, or
              decisions made based on information provided by the app.
            </p>

            <h1 className="headerInfo2">10. Third-party services</h1>
            <p>
              The app may integrate third-party services whose terms and
              policies also apply, including:
            </p>
            <ul>
              <li>
                <a
                  href="https://www.revenuecat.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  RevenueCat
                </a>
              </li>
            </ul>

            <h1 className="headerInfo2">11. Termination</h1>
            <p>
              We may suspend or terminate your access to the app if you breach
              these Terms or for operational reasons. Unless stated otherwise,
              upon termination the rights and licenses granted to you will cease
              and you must stop using the app.
            </p>

            <h1 className="headerInfo2">12. Changes to these Terms</h1>
            <p>
              We may update these Terms. We will publish the current version and
              its effective date on this page. Continued use of the app after
              changes implies acceptance of the new Terms.
            </p>

            <h1 className="headerInfo2">13. Contact</h1>
            <p>
              If you have questions or suggestions about these Terms, write to{" "}
              <span style={{ color: "#DD3D99" }}>coloryouapp@gmail.com</span>.
            </p>

            <span className="sep"></span>
            <br />

            <p>Effective date: 2025-09-08</p>
          </article>
        </div>
      </div>
    </div>
  );
};
